<template>
    <div id="app">
        <v-app>
            <AutoUpdater />
            <LayoutMessages />

            <Transition
                name="quick-fade"
                mode="out-in"
                appear
            >
                <component
                    :is="current_layout"
                    :key="route.meta.layout"
                >
                    <router-view
                        v-slot="{ Component }"
                        key="app-booted"
                    >
                        <Transition
                            name="quick-fade"
                            mode="out-in"
                            appear
                        >
                            <component
                                :is="Component"
                                :key="route.fullPath"
                            />
                        </Transition>
                    </router-view>
                </component>
            </Transition>
        </v-app>
    </div>
</template>

<script setup lang="ts">
import { type Component, computed } from "vue";

import { useRoute } from "vue-router";
import { useHead } from "@unhead/vue";

import BlankLayout from "./layouts/BlankLayout/BlankLayout.vue";
import DashboardLayout from "./layouts/DashboardLayout/DashboardLayout.vue";
import DashboardAuthLayout from "./layouts/DashboardAuthLayout/DashboardAuthLayout.vue";
import AutoUpdater from "./shared/components/auto-updater/AutoUpdater.vue";
import LayoutMessages from "./shared/components/layout-messages/LayoutMessages.vue";
import { LayoutName } from "@/shared/types/general";

/*###########
### SETUP ###
########## */
const route = useRoute();

const REGISTERED_LAYOUTS: Record<LayoutName, Component> = {
    [LayoutName.BLANK]: BlankLayout,
    [LayoutName.DASHBOARD]: DashboardLayout,
    [LayoutName.DASHBOARD_AUTH]: DashboardAuthLayout
};
const current_layout = computed(() => {
    return REGISTERED_LAYOUTS[route.meta.layout];
});

useHead({
    title: "Bramka do fakturowania | AV Invoicing Gateway"
});
</script>
